export default Object.freeze({
  TITLE: '취소 관리',
  EXCHANGE_TITLE: '교환 관리',
  CLAIMTYPELABELSPAN: '취소',
  EXCHANGE_CLAIMTYPELABELSPAN: '교환',
  RETURN_TITLE: '반품 관리',
  RETURN_CLAIMTYPELABELSPAN: '반품',
  CLAIMTYPELABELSPAN_AFTER: '지연',
  CLAIMTYPELABELSPAN_COUNT: '건',
  TABLE_TITLE: '조회결과',
  TABLE_TITLE_OTHER: '취소지연 조회결과',
  EXCHANGE_TABLE_TITLE_OTHER: '교환지연 조회결과',
  RETURN_TABLE_TITLE_OTHER: '반품지연 조회결과',
  PLATFORMTYPES_LENGTH_ERROR: '조회하려는 플랫폼구분을 체크해주세요',
  CLAIMSTATUSTYPES_LENGTH_ERROR: '조회하려는 클레임상태를 체크해주세요',
});
